import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "sonner";
import axiosApiClient from "../../../api";

// Load cart from localStorage
export const loadCart = createAsyncThunk("cart/load", async () => {
  try {
    const savedCart = JSON.parse(localStorage.getItem("cart") || "[]");
    return savedCart;
  } catch (error) {
    console.error("Error loading cart:", error);
    return [];
  }
});

// Add item to cart
export const addToCart = createAsyncThunk(
  "cart/addItem",
  async ({ courseId }, { getState }) => {
    try {
      const state = getState();

      // Find course in the courses state (check both courses and featuredCourses)
      let course = state.courses.courses.find((c) => c.id === courseId);
      if (!course) {
        course = state.courses.featuredCourses.find((c) => c.id === courseId);
      }
      if (!course) {
        console.log("Available courses:", state.courses.courses);
        console.log(
          "Available featured courses:",
          state.courses.featuredCourses,
        );
        console.log("Looking for courseId:", courseId);
        throw new Error("Kurs nije pronađen");
      }

      const existingItem = state.cart.items.find(
        (item) => item.courseId === courseId,
      );

      if (existingItem) {
        // If item already exists, don't add again
        toast.info(`Kurs "${course.title}" je već u korpi!`);
        return null; // Return null to indicate no change
      } else {
        // Add new item
        const cartItem = {
          courseId: course.id,
          title: course.title,
          description: course.shortDescription || course.description,
          price: course.discountPrice || course.price,
          currency: course.currency,
          thumbnailImage: course.thumbnailImage,
          addedAt: new Date().toISOString(),
        };
        toast.success(`Kurs "${course.title}" je dodat u korpu!`);
        return cartItem;
      }
    } catch (error) {
      toast.error(error.message || "Greška pri dodavanju u korpu");
      throw error;
    }
  },
);

// Remove item from cart
export const removeFromCart = createAsyncThunk(
  "cart/removeItem",
  async (courseId, { getState }) => {
    try {
      const state = getState();
      const item = state.cart.items.find((item) => item.courseId === courseId);

      if (item) {
        toast.success(`Kurs "${item.title}" je uklonjen iz korpe`);
      }

      return courseId;
    } catch (error) {
      toast.error("Greška pri uklanjanju iz korpe");
      throw error;
    }
  },
);

// Clear entire cart
export const clearCart = createAsyncThunk("cart/clear", async () => {
  return [];
});

// Apply promo code
export const applyPromoCode = createAsyncThunk(
  "cart/applyPromo",
  async (promoCode, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const courseIds = state.cart.items.map((item) => item.courseId);

      const response = await axiosApiClient.post("/orders/validate-promo", {
        code: promoCode,
        courseIds,
      });

      const { promo } = response.data;
      toast.success(`Promo kod primenjen: ${promo.name}`);
      return promo;
    } catch (error) {
      const message =
        error.response?.data?.message || "Greška pri primeni promo koda";
      toast.error(message);
      return rejectWithValue(message);
    }
  },
);
